import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./DraftApplications.css";
import { useNavigate } from "react-router-dom";
import { writeFileAsync } from "xlsx";
import { fetchDraftApplicatrions, deleteDraft, resendPersonalInfoLink } from "../../../../services/draftApplicationService";
import { capitalizeFirstLetter } from "../../../../utils/validations";
import { XOctagon } from "lucide-react";
import { Zoom } from "@mui/material";

const DraftApplications = () => {
  const [drafts, setDrafts] = useState([]);
  const navigate = useNavigate();

  const effectRan = useRef(false);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const employeeUniqueId = storedUser?.employeeUniqueId;
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [employeeData, setEmployeeData] = useState({});
  let districtId = localStorage.getItem("districtId");
  districtId = districtId && districtId !== "null" ? Number(districtId) : null;

  let zoneId = localStorage.getItem("zoneId");
  zoneId = zoneId && zoneId !== "null" ? Number(zoneId) : null;
  const fetchDrafts = async () => {
    try {
      //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/selected-statuses`);
      const response = await fetchDraftApplicatrions(districtId,zoneId);
      console.log("API response data:", response.data);
      setDrafts(response.data ?? []);
    } catch (err) {
      console.error("Failed to load draft applications", err);
    }
  };


  const apmRoleNameGet = localStorage.getItem("role");


  useEffect(() => {
    if (effectRan.current === false) {
      fetchDrafts();
    }
    return () => {
      effectRan.current = true;
    }
  }, []);


  const handleApplicationClick = (appId) => {
    console.log("Navigating to registrationnavbar with appId:", appId);
    navigate("/registrationnavbar", {
      state: { applicationId: appId },
    });
  };
  localStorage.removeItem("personalData");


  const handleDelete = async (employeeUniqueId) => {
    try {
      await deleteDraft(employeeUniqueId);

      setDrafts((prevDrafts) =>
        prevDrafts.filter((app) => app.employeeUniqueId !== employeeUniqueId)
      );

      setSuccessMessage(`Draft application deleted successfully. Temporary ID - ${employeeUniqueId}`);
    } catch (err) {
      console.error("Failed to delete draft application", err);
      alert("Failed to delete draft application. Please try again.");
    }
  };

  const handleResendLink = async (employeeUniqueId) => {
    // AuditLogRequest payload expected by backend
    const payload = {
      name: localStorage.getItem("full_name") || "",
      role: localStorage.getItem("role") || "",
      employeeId: localStorage.getItem("employeeId") || "",
    };

    try {
      // call service and await
      const data = await resendPersonalInfoLink(employeeUniqueId, payload);

      // data can be whatever backend returns; show success
      setSuccessMessage(`Link sent successfully! Temporary ID - ${employeeUniqueId}`);

      // clear success message after 8s (existing behavior)
      setTimeout(() => setSuccessMessage(""), 8000);

      // refresh list or drafts
      fetchDrafts();

      return data;
    } catch (err) {
      console.error("❌ Failed to resend link", err);
      alert("Failed to resend link. Please try again.");
      // optionally return or rethrow
      throw err;
    }
  };

  // const handleEdit = async (id) => {
  //   if (!id) {
  //     console.error("❌ Employee ID is missing");
  //     return;
  //   }

  //   try {
  //     const payload = {
  //       firstName: employeeData.firstName || "",
  //       lastName: employeeData.lastName || "",
  //       dob: employeeData.dob || "",
  //       gender: { id: employeeData.gender?.id || 1 }, // check backend requirement
  //       email: employeeData.email || "",
  //       mobile: employeeData.mobile || "",
  //       jobPosition: employeeData.jobPosition || "",
  //     };

  //     console.log("PATCH payload:", payload);

  //     const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/employees/${id}`,payload,{ headers: { "Content-Type": "application/json" } });

  //     console.log("✅ Employee updated:", res.data);
  //     navigate(`employeeCreation`);
  //   } catch (err) {
  //     console.error("❌ Failed to update employee profile", err.response?.data || err);
  //   }
  // };


  useEffect(() => {
    return () => {
      localStorage.removeItem("applicationNumber");
      localStorage.removeItem("applicationPrimaryKey");
    };
  }, []);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);
  // const capitalizeFirstLetter = (str) => {
  //   if (!str) return "";
  //   return str
  //     .split(" ")
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  //     .join(" ");
  // };
  return (
    <div>
      <div className="table-view">
        <div className="table-header">
          <div className="table-col">Full Name</div>
          <div className="table-col">District</div>
          <div className="table-col">Job Position</div>
          <div className="table-col">Mobile Number</div>
          <div className="table-col">Updated By</div>
          <div className="table-col">Status</div>
          <div className="table-col">Date and Time</div>

          {(apmRoleNameGet !== "APM" &&
            apmRoleNameGet !== "PM" &&
            apmRoleNameGet !== "APM Zone" &&
            apmRoleNameGet !== "APM OPERATIONS") && (
              <div className="table-col">Action</div>
            )}
        </div>

        {drafts.length > 0 ? (
          drafts.map((app, index) => {
            // Format updated date
            const formattedDate = app.updatedDate
              ? new Intl.DateTimeFormat("en-GB")
                .format(new Date(app.updatedDate))
                .replace(/\//g, "-")
              : "N/A";

            const formattedTime = app.updatedDate
              ? new Date(app.updatedDate).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
              : "";

            return (
              <div key={index} className="table-row">
                {/* FULL NAME */}
                <div className="table-col">{app.fullname || "N/A"}</div>
                <div className="table-col">{app.district || "N/A"}</div>
                {/* JOB POSITION */}
                <div className="table-col">{app.jobposition || "N/A"}</div>

                {/* MOBILE */}
                <div className="table-col">{app.contactNumber || "N/A"}</div>

                {/* UPDATED BY */}
                <div className="table-col">{app.filledByName || "N/A"}</div>

                {/* STATUS */}
                <div className="table-col">
                  {app.status
                    ? app.status.charAt(0).toUpperCase() +
                    app.status.slice(1).toLowerCase()
                    : "N/A"}
                </div>

                {/* DATE + TIME */}
                <div className="table-col">
                  {formattedDate}, {formattedTime}
                </div>

                {/* ACTION BUTTONS (if allowed) */}
                {(apmRoleNameGet !== "APM" &&
                  apmRoleNameGet !== "PM" &&
                  apmRoleNameGet !== "APM Zone" &&
                  apmRoleNameGet !== "APM OPERATIONS") && (
                    <div className="table-col">
                      <select
                        className="action-dropdown-draft"
                        onChange={(e) => {
                          const action = e.target.value;

                          if (action === "retrieve") {
                            handleApplicationClick(app.employeeUniqueId);
                          } else if (action === "delete") {
                            setConfirmDeleteId(app.employeeUniqueId);
                          } else if (action === "resend") {
                            handleResendLink(app.employeeUniqueId);
                          }

                          e.target.value = "";
                        }}
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select Action
                        </option>
                        <option value="retrieve" className="retrieve-option">
                          Complete Profile
                        </option>
                        <option value="resend" className="resend-option">
                          Send Link
                        </option>
                        <option value="delete" className="delete-option">
                          Delete Profile
                        </option>
                      </select>
                    </div>
                  )}
              </div>
            );
          })
        ) : (
          <p>No draft applications found.</p>
        )}
      </div>

      {confirmDeleteId && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <p>Do you really want to delete it?</p>
            <div className="confirm-actions">
              <button
                className="btn-colors"
                type="button"
                onClick={async () => {
                  await handleDelete(confirmDeleteId);
                  setConfirmDeleteId(null);
                }}
              >
                Yes
              </button>
              <button
                className="btn-colors"
                type="button"
                onClick={() => setConfirmDeleteId(null)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {successMessage && (
        <div className="confirm-overlay">
          <div className="success-message-popup">{successMessage}</div>
        </div>
      )}
    </div>
  );

};

export default DraftApplications;
